export default "__VITE_ASSET__7989c944__"